export enum BusinessSavingsTypeEnum {
  VAULT = "vault",
  FIXED_DEPOSITS = "fixed-deposits",
}
